module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/accordian/accordian-style5/accordian-style5.component.scss
// module id = ./src/app/features/accordian/accordian-style5/accordian-style5.component.scss
// module chunks = main